import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dayjs from 'vue-dayjs'
import axios from 'axios'
import VueAxios from 'vue-axios'
import AOS from 'aos'
import { register } from 'swiper/element/bundle';
import Vue2Editor from "vue2-editor";

import VueMeta from 'vue-meta';
import 'aos/dist/aos.css'


import {url} from './global/index'; 

Vue.use(dayjs)
Vue.use(Vue2Editor);
Vue.use(VueAxios, axios)
Vue.use(VueMeta);

axios.defaults.baseURL =url;

Vue.config.productionTip = false
register();

new Vue({
  created() {
    AOS.init();
  },
  router,
  store, 
  render: h => h(App),
}).$mount('#app')
